import { debugLog } from '../components/ui/debugPopup'

const BASE_URL = import.meta.env.API_BASE_URL || 'https://mapi.tevi.dev'

const getHeaders = (token) => {
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
  }
}

const logCurl = (url, method, headers, body) => {
  const parts = [`curl -X ${method} '${url}'`]
  Object.entries(headers).forEach(([k, v]) => {
    parts.push(`  -H '${k}: ${v}'`)
  })
  if (body) parts.push(`  -d '${body}'`)
  debugLog('cURL', parts.join(' \\\n'))
}

// Basic format validation for Tevi ID (used when SDK is not available)
export const validateTeviId = async (teviId) => {
  if (!teviId || teviId.trim().length === 0) {
    return { status: 'valid', message: '' }
  }

  if (!/^\d+$/.test(teviId)) {
    return { status: 'invalid', message: 'Please enter a valid ID' }
  }

  if (teviId.length < 5) {
    return { status: 'invalid', message: 'Please enter a valid ID' }
  }

  return { status: 'valid', message: '' }
}

// Submit MCN invitation via POST /mcn-invitation/api/v1/invite
export const submitMCNApplication = async ({ teviId, token }) => {
  const url = `${BASE_URL}/mcn-invitation/api/v1/invite`
  const headers = getHeaders(token)
  const body = JSON.stringify({ user_id: teviId })
  logCurl(url, 'POST', headers, body)

  const response = await fetch(url, {
    method: 'POST',
    headers,
    body,
  })

  const result = await response.json()

  if (!response.ok || !result.success) {
    return {
      success: false,
      message: result.message || 'Failed to send invitation. Please try again.',
    }
  }

  return {
    success: true,
    message: 'Invitation sent successfully!',
    data: result.data,
  }
}
